import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStates } from "../ApiService/ApiService";

export const fetchStatesAsync = createAsyncThunk(
  "states/fetchStates",
  async () => {
    const response = await getStates();
    return response.data;
  }
);

const initialState = {
  states: [],
  loading: false,
  error: null,
};

export const statesSlice = createSlice({
  name: "states",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload.data;
      })
      .addCase(fetchStatesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllStates = (state) => state.states.states;
export const selectStatesLoading = (state) => state.states.loading;
export const selectStatesError = (state) => state.states.error;

export default statesSlice.reducer;
